import { lazy } from 'react';


export const NoticesAndEvents = lazy(() => import('./notices_events/NoticesAndEvents'));
export const NoticeList = lazy(() => import('./notice/NoticeList'));
export const NoticeDetails = lazy(() => import('./notice/NoticeDetails'));
export const PollList = lazy(() => import('./poll/PollList'));
export const PollDetails = lazy(() => import('./poll/PollDetails'));
export const EventList = lazy(() => import('./event/EventList'));
export const EventDetails = lazy(() => import('./event/EventDetails'));
export const EventCalendar = lazy(() => import('./event/EventCalendar'));